/* global angular */
/* eslint-disable max-params */
( function () {
	'use strict';

	/* @ngInject */
	function MathInterface ( $scope, $modalInstance, mathService, mathOperatorService, formulaService, groupModel, loadTemplateMask, apiService, templateHolder, logger, _, $modal, math ) {
		var self = this;

		var modalConfig = {
			'templateUrl' : '/templates/components/math/interface/math-io-rubric-container.html',
			'keyboard'    : false,
			'windowClass' : 'math-rubric-container-modal',
			'size'        : 'lg',
			'backdrop'    : 'static',
			'scope'       : $scope
		};

		var confirmModalConfig = {
			'templateUrl' : '/templates/components/math/interface/math-io-rubric-confirm.html',
			'keyboard'    : false,
			'windowClass' : 'math-rubric-confirm-modal',
			'size'        : 'md',
			'scope'       : $scope
		};

		var invalidModalConfig = {
			'templateUrl' : '/templates/components/math/interface/math-io-invalid-modal.html',
			'keyboard'    : false,
			'windowClass' : 'math-invalid-modal',
			'size'        : 'lg',
			'scope'       : $scope
		};

		var rubricDefault = {
			'answerOptions' : [ {
				'description' : 'Description 1',
				'optionText'  : 'Title 1'
			}, {
				'description' : 'Description 2',
				'optionText'  : 'Title 2'
			} ]
		};

		self.copiedModel = angular.copy( groupModel.itemList );

		self.showLoading                 = false;
		self.oldFormula                  = '';
		self.rubricModalInstance         = null;
		self.rubricConfirmModalInstance  = null;
		self.formulaInvalidModalInstance = null;
		self.oldRubric                   = '';
		self.invalidFormula              = false;
		self.lastRubric                  = null;

		// this is to prevent closing modal on first open
		self.internal = { 'cleanModel' : true };

		// build object array from string formula
		function buildFormula () {
			if ( !self.groupModel.formula ) {
				return [];
			}
			return formulaService.aliasValues( self.model, self.groupModel.formula );
		}

		function setHtmlPaths () {
			// set include paths to break down html
			var basePath       = '/templates/components/math/interface/';

			self.buttonPath    = basePath + 'math-io-buttons.html';
			self.indicatorPath = basePath + 'math-io-indicators.html';
		}

		function setControllerBindings () {
			// default operator bindings
			self.model = mathOperatorService.getDisplay();

			// provides button grouping on display
			self.operatorGroups = mathOperatorService.getOperatorGroup();

			// bind caller model to groupModel
			self.callerModel = groupModel.itemList;
			self.groupModel  = angular.copy( groupModel.itemList );
			self.prefix      = groupModel.prefix;
			self.itemKey     = groupModel.itemKey;
			self.nameKey     = groupModel.nameKey;
			self.formulaName = groupModel.formulaName;
			self.viewMode    = groupModel.viewMode;
			self.score       = groupModel.score;

			// initialize formula components
			self.formula = [];
			self.status = {
				'msg' : ''
			};
		}

		function buildKey ( index ) {
			return '[ ' + self.prefix + ' ' + ( index + 1 ) + ' ]';
		}

		function indicatorMapper ( indicator, index ) {
			mathService.bindModel( buildKey( index ), indicator );
		}

		function registerIndicators () {
			self.groupModel[ self.itemKey ].map( indicatorMapper );
		}

		function getMaxRubric ( prev, cur ) {
			return cur.maxRange > prev && cur.maxRange || prev;
		}

		function procesReplacement () {
			var rubricItems = self.groupModel.rubric;
			var rubricMask  = self.modelReplacement.rubric.answerOptions;
			var maxRubric   = rubricItems.reduce( getMaxRubric, 0 );
			var newScore    = self.groupModel.score;

			if ( !isNaN( self.score ) ) {
				newScore = self.score;
			}

			rubricItems.map( function ( rubric, index ) {
				rubricMask[ index ].selected = newScore > rubric.minRange && newScore <= rubric.maxRange;

				if ( rubricMask[ index ].selected ) {
					self.proficiencyReplacement = rubric.title;
				}
			} );

			function forceRubricSelection ( index ) {
				rubricMask[ index ].selected = true;
				self.proficiencyReplacement = rubricItems[ index ].title;
			}

			if ( newScore < 0 ) {
				forceRubricSelection( 0 );
			} else if ( newScore > maxRubric ) {
				forceRubricSelection( rubricItems.length - 1 );
			}

			if ( !self.proficiencyReplacement || !self.proficiencyReplacement.length ) {
				self.proficiencyReplacement = rubricMask[ rubricMask.length - 1 ].title;
			}
		}

		function getRubric () {
			self.modelReplacement = {};
			self.proficiencyReplacement = '';
			loadTemplateMask.processRubric( self.groupModel, self.modelReplacement );
			if ( self.modelReplacement.rubric ) {
				procesReplacement();
			}
		}

		function activate () {
			setHtmlPaths();
			setControllerBindings();
			mathService.initialize( self, self.model, self.groupModel, self.status );
			registerIndicators();
			self.formula = buildFormula();
			if ( self.groupModel.rubric ) {
				self.getRubric();
			}

			var operators = [ '+', '-', '*', '/', ',', '(', ')' ];
			var allOptr   = mathOperatorService.getDisplay().map( function ( optr ) {
				return optr.value.id;
			} );

			self.operatorFn = _.xor( operators, allOptr );
			self.openFn     = false;

			self.formulaHolder    = angular.copy( groupModel.itemList.formula );
			// this is for rubric
			self.groupData        = self.groupModel;
			self.untouchedFormula = angular.copy( groupModel.itemList.formula );
			self.untouchedRubric  = angular.copy( self.groupModel.rubric );
			self.lastRubric       = self.untouchedRubric;
		}

		function close () {
			$modalInstance.close();
		}

		function addNumberToFormula () {
			mathService.addNumberToFormulaHandler( self.tempNumHolder );
			self.tempNumHolder = 0;
		}

		function isLastNumber () {
			return self.formula && self.formula.length
				// identifies last component as a number
				&& ( self.formula[ self.formula.length - 1 ].indexOf( 'num' ) === 0
				// identifies last component as a value
				|| self.formula[ self.formula.length - 1 ].indexOf( '[ ' ) === 0 );
		}

		function isPrevented ( indicator ) {
			return indicator
				// prevent label and open-ended for beta
				&& ( ( indicator.type === 5 || ( indicator.type === 1 && !angular.isDefined( indicator.score ) ) )
				// prevent groups with no formula
				|| ( self.prefix === 'Group' && !indicator.formula )
				// prevent if last input is a value
				|| isLastNumber() );
		}

		function replaceTemplateFormula ( oldGroupId, newGroupId, templateModel ) {
			if ( ( templateModel.formula || '' ).indexOf( oldGroupId ) > -1  ) {
				templateModel.formula = ( templateModel.formula || '' ).split( oldGroupId ).join( newGroupId );
			}
		}

		function alterTemplateFormula ( oldId, newId ) {
			templateHolder.alter( function ( templateModel ) {
				replaceTemplateFormula( oldId, newId, templateModel );
			} );
		}

		function addToFormula ( key ) {
			mathService.addToFormula( key );
			self.formulaHolder = angular.copy( groupModel.itemList.formula );
		}

		function addIndicatorToFormula ( index ) {
			addToFormula( buildKey( index ) );
		}

		function removeRubric () {
			delete self.groupModel.rubric;
			delete self.lastRubric;
			self.rubricConfirmModalInstance.close();
			self.rubricModalInstance.close();
		}

		function confirmRemoveRubric () {
			self.rubricConfirmModalInstance = $modal.open( confirmModalConfig );
		}

		function clearChangeId () {
			if ( self.formulaHolder !== '' && self.formulaHolder !== undefined && self.formulaHolder !== null ) {
				self.formulaHolder = angular.copy( groupModel.itemList.formula );
			}
		}

		function preCleanFormula ( formula ) {
			// currently, we are saving the averaging function as 'avg'. The mathjs library handles 'mean' natively, so
			//   we are converting for that.
			formula = formula.replace( /avg/g, 'mean' );

			// removing the spaces to make the checks easier.
			formula = formula.replace( / /g, '' );

			// items within formulas should be separated by a comma, so we shouldn't ever see `][`
			if ( formula.match( /\]\[/ ) ) {
				formula = NaN;
			}
			return formula;
		}

		function postCleanFormula ( formula ) {
			// after all the replacement, we end up with the possibility of a bunch of bad strings. We're removing the problems here.
			formula = formula.replace( /\,\[\:xx\:\]/g, '' );
			formula = formula.replace( /\(\[\:xx\:\],/, '(' );
			formula = formula.replace( /,\[\:x/g, '' );
			formula = formula.replace( /x\:\]\,/g, ',' );
			formula = formula.replace( /\(\[\:x/g, '(' );
			formula = formula.replace( /x\:\]\)/g, ')' );
			formula = formula.replace( /\[|\:|\]/g, '' );

			// only replacing the empty sum() with 0. Any empty mean() should return NaN
			formula = formula.replace( /sum\(\)/g, '0' );

			// replace uuid with a valid number
			formula = formula.replace( /[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}/g, '1' );
			return formula;
		}

		function validateFormula () {
			var score, newFormula;
			var formula = angular.copy( self.groupModel.formula );

			try {
				newFormula = postCleanFormula( preCleanFormula( formula ) );
				score = math.eval( newFormula );
			} catch ( err ) {
				score = NaN;
			}

			self.invalidFormula = isNaN( score );
		}

		function initUntouchedData () {
			self.untouchedFormula = angular.copy( self.groupModel.formula );
			self.untouchedRubric  = angular.copy( self.groupModel.rubric );
		}

		function compareValidate () {
			self.invalidFormula = false;
			if ( self.oldFormula !== '' && self.groupModel.formula === '0' ) {
				self.invalidFormula = true;
			} else {
				self.validateFormula();
			}
		}

		function addRubric () {
			compareValidate();

			if ( !self.invalidFormula ) {
				self.rubricModalInstance = $modal.open( modalConfig );
				self.groupModel.rubric   = angular.copy( rubricDefault );
			} else {
				self.formulaInvalidModalInstance = $modal.open( invalidModalConfig );
			}
		}

		function editRubric () {
			compareValidate();

			if ( !self.invalidFormula ) {
				self.callerModel.formula = self.groupModel.formula;
				self.rubricModalInstance = $modal.open( modalConfig );
			} else {
				self.formulaInvalidModalInstance = $modal.open( invalidModalConfig );
			}
		}
		// === end of formula validation ===

		function startOfMathFn ( item ) {
			return item === this.formulaItem;
		}

		function iterateFormula ( formula ) {
			var isMath = ( self.operatorFn || [] ).some( startOfMathFn.bind( { 'formulaItem' : formula } ) );

			if ( isMath ) {
				self.openFn = true;
			}

			if ( formula === ')' ) {
				self.openFn = false;
			}
			return isMath;
		}

		function disableBtn ( operator ) {
			var equation = null;

			self.openFn = false;
			equation    = ( self.formula || [] ).map( iterateFormula );

			if ( !equation.length ) {
				self.openFn = false;
			}

			return ( operator.key !== ')' && operator.key !== ',' ) && self.openFn;
		}

		function cancelChanges () {
			$modalInstance.dismiss();
		}

		function saveChanges () {
			compareValidate();

			if ( self.invalidFormula ) {
				delete self.groupModel.rubric;
				delete self.lastRubric;
			}

			if ( !( self.untouchedFormula !== self.groupModel.formula || !angular.equals( self.untouchedRubric, self.groupModel.rubric  ) ) ) {
				initUntouchedData();
				// just dismiss the modal if the formula has no changes/untouched
				cancelChanges();
			} else {
				self.showLoading         = true;
				self.internal.cleanModel = false;

				if ( self.groupModel.id ) {
					self.groupModel.id  = apiService.generateUUID();
					self.callerModel.id = self.groupModel.id;
				}

				if ( self.groupModel.rubric ) {
					self.callerModel.rubric = self.groupModel.rubric;
				} else {
					delete self.callerModel.rubric;
				}

				self.callerModel.formula = self.groupModel.formula;
				self.alterTemplateFormula( self.copiedModel.id, self.groupModel.id );
			}
		}

		function isValidScore ( score ) {
			return parseFloat( score );
		}

		function hasAvgOrSum () {
			var formula  = self.formula;
			var hasFound = false;

			if ( formula.indexOf( 'avg(' ) >= 0 || formula.indexOf( 'sum(' ) >= 0 ) {
				hasFound = true;
			}

			return hasFound;
		}

		function getFormula () {
			self.oldFormula = self.groupModel.formula;
		}

		function save () {
			self.lastRubric = angular.copy( self.groupModel.rubric );
			self.rubricModalInstance.close();
		}

		function cancel () {
			if ( self.lastRubric ) {
				self.groupModel.rubric = angular.copy( self.lastRubric );
			} else {
				delete self.groupModel.rubric;
			}
			self.rubricModalInstance.close();
		}

		function closeInvalidFormulaModal () {
			self.formulaInvalidModalInstance.close();
		}

		function cancelConfirmation () {
			self.rubricConfirmModalInstance.close();
		}

		function formatScore ( score ) {
			var formattedScore = null;

			if ( score ) {
				formattedScore = parseFloat( score ).toFixed( 2 );
			}

			return formattedScore;
		}

		// listeners
		$scope.$on( 'math:save:close', function () {
			if ( !self.internal.cleanModel ) {
				self.close();
			}
		} );

		$scope.$on( 'math:stop:loading', function () {
			self.showLoading = false;
			initUntouchedData();
			// recopy model to reflect new changes from group model source
			self.copiedModel = angular.copy( groupModel.itemList );
		} );

		// handlers
		self.addNumberToFormula    = addNumberToFormula;
		self.addIndicatorToFormula = addIndicatorToFormula;
		self.alterTemplateFormula  = alterTemplateFormula;
		self.addRubric             = addRubric;
		self.removeRubric          = removeRubric;
		self.getRubric             = getRubric;
		self.close                 = close;
		self.clear                 = mathService.clear;
		self.getMath               = mathService.getMath;
		self.addToFormula          = addToFormula;
		self.isPrevented           = isPrevented;
		self.isLastNumber          = isLastNumber;
		self.buildKey              = buildKey;
		self.clearChangeId         = clearChangeId;
		self.saveChanges           = saveChanges;
		self.cancelChanges         = cancelChanges;
		self.validateFormula       = validateFormula;
		self.compareValidate       = compareValidate;
		self.disableBtn            = disableBtn;
		self.isValidScore          = isValidScore;
		self.hasAvgOrSum           = hasAvgOrSum;
		self.getFormula            = getFormula;
		self.save                  = save;
		self.editRubric            = editRubric;
		self.cancel                = cancel;
		self.confirmRemoveRubric   = confirmRemoveRubric;
		self.cancelConfirmation    = cancelConfirmation;
		self.closeInvalidModal     = closeInvalidFormulaModal;
		self.formatScore           = formatScore;

		self.internalMethods = {
			'replaceTemplateFormula' : replaceTemplateFormula
		};

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'MathInterface', MathInterface );

	MathInterface.$inject = [ '$scope', '$modalInstance', 'mathService', 'mathOperatorService', 'formulaService', 'groupModel', 'loadTemplateMask', 'apiService', 'templateHolder', 'logger', '_', '$modal', 'math' ];
} )( );
